import * as React from 'react';
import { FC } from 'react';
import type { Locales, Values, ChangeValues } from './types';

const Terms: FC<{
  values: Values;
  changeValues: ChangeValues;
  locales: Locales;
}> = ({ values, changeValues, locales }) => (
  <div className="input boolean player_terms">
    <input
      type="checkbox"
      checked={values.terms}
      onChange={() => changeValues({ terms: !values.terms })}
      name="player[terms]"
      id="player_terms"
    />
    <label htmlFor="player_terms">
      <span dangerouslySetInnerHTML={{ __html: locales.attributes.terms }} />
    </label>
  </div>
);

export default Terms;
